import React from "react";
import Card from "react-bootstrap/Card";
import { Trans, useTranslation } from "react-i18next";

function AboutCard() {
  const { t } = useTranslation();
  return (
    <Card className="policy-card about-card about-who-card" aria-label={t("aboutWho.a11y.overviewCardLabel")}>
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="about-text">
            <Trans
              i18nKey="aboutWho.overview.p1"
              components={{ r: <span className="small-r-symbol">®</span> }}
            />
          </p>

          <p className="about-text">
            {t("aboutWho.overview.p2")}
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
